module.exports = "/static/assets/97f7616dd4aac96ea35bab53a4b3642f.png";